import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, MenuItem, IconButton, Stack
  } from '@mui/material';
  import { useState } from 'react';
  import DeleteIcon from '@mui/icons-material/Delete';
  
  const durations = ['Monthly', 'Quarterly', 'Yearly'];
  
  export const InstallmentPopup = ({ open, onClose, onSave }) => {
    const [numInstallments, setNumInstallments] = useState('');
    const [installments, setInstallments] = useState([
      { duration: '', amount: '' }
    ]);
  
    const handleChange = (index, field, value) => {
      const updated = [...installments];
      updated[index][field] = value;
      setInstallments(updated);
    };
  
    const handleAddRow = () => {
      setInstallments([...installments, { duration: '', amount: '' }]);
    };
  
    const handleDeleteRow = (index) => {
      const updated = [...installments];
      updated.splice(index, 1);
      setInstallments(updated);
    };
  
    const handleSave = () => {
      const formatted = `Number of Installments: ${numInstallments}, ` + 
        installments
          .filter(item => item.duration && item.amount)
          .map(item => `Installment: ${item.duration} - PKR ${item.amount}`)
          .join(', ');
      onSave(formatted);
      onClose();
    };
  
    return (
      <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle variant='h2'>Installment Details</DialogTitle>
        <DialogContent>
          <TextField
            label="Number of Installments"
            type="number"
            size='small'
            value={numInstallments}
            onChange={(e) => setNumInstallments(e.target.value)}
            fullWidth
            sx={{ mt: 1 }}
          />
  
          {installments.map((item, index) => (
            <Stack key={index} direction="row" spacing={2} alignItems="center" mt={2}>
              <TextField
                select
                label="Duration"
                size='small'
                value={item.duration}
                onChange={(e) => handleChange(index, 'duration', e.target.value)}
                fullWidth
              >
                {durations.map(option => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </TextField>
              <TextField
                label="Amount"
                size='small'
                type="number"
                value={item.amount}
                onChange={(e) => handleChange(index, 'amount', e.target.value)}
                fullWidth
              />
              <IconButton onClick={() => handleDeleteRow(index)}>
                <DeleteIcon />
              </IconButton>
            </Stack>
          ))}
  
          <Button onClick={handleAddRow} sx={{ mt: 2 }}>Add More</Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined">Cancel</Button>
          <Button onClick={handleSave} sx={{color:'white'}} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    );
  };
  